import { Typography } from '@material-ui/core';
import React from 'react';

export default function About() {
  return <Typography>About us</Typography>;
}
